import { apiClient } from "@lib/axios";

export interface IStoriesFolderCreateParams {
  title: string;
  parentId?: string;
}

export interface IStoriesFolderUpdateParams {
  id: string;
  title: string;
  /**
   * The folder to sit under. Null moves it to the top level: the endpoint puts
   * the body straight into a $set, so null unsets the parent the same way the
   * tree reads an absent one.
   */
  parentId?: string | null;
}

export interface IStoriesFolderCountResponse {
  count: number;
}

export const storiesFolderApi = {
  getStoriesFolders: () => {
    return apiClient.get("/folders");
  },

  getStoriesFoldersCount: () => {
    return apiClient.get<IStoriesFolderCountResponse>("/folders/count");
  },

  createStoriesFolder: (data: IStoriesFolderCreateParams) => {
    return apiClient.post("/folders", data);
  },

  updateStoriesFolder: (data: IStoriesFolderUpdateParams) => {
    const { id, ...updateData } = data;
    return apiClient.put(`/folders/${id}`, updateData);
  },

  deleteStoriesFolder: (id: string) => {
    return apiClient.delete(`/folders/${id}`);
  },
};
